export const setting_ze = {
    home:{
        en:'Home',
        zh:'首页'
    },
    aboutme:{
        en:'About',
        zh:'关于我'
    },
    projects:{
        en:'Project',
        zh:'我的项目'
    },
    skills:{
        en:'Skills',
        zh:'我的技能'
    },
    experience:{
        en:'Experience',
        zh:'我的经历'
    },
    projects:{
        en:'projects',
        zh:'我的项目'
    },
    name:{
        en:'XiaoBai',
        zh:'小白'
    },
    begin:{
        en:'Hello, I am',
        zh:'你好，我是'
    },
    desc:{
        en:"Front end white.",
        zh:'前端小白'
    },
    typewriter:{
        en:["Be keen on studying new technologies.","Be good at summing up."],
        zh:['热衷于钻研新技术', '善于总结']
    },
    resume:{
        en:'Download resume',
        zh:'下载简历'
    },
    git:{
        en:'Gitee',
        zh:'码云'
    },
    bk:{
        en:'Personal blog',
        zh:'个人博客'
    },
    about_title:{
        en:'About me',
        zh:'关于我'
    },
    about:{
        zh:`
        我是一个热爱编程的年轻人，喜欢探索新技术，喜欢挑战自己，喜欢解决问题。

        我会努力学习和提升自己的技能，希望能够为团队做出贡献。我的技术栈包括HTML、CSS、JavaScript、Vue.js、React等。
       
        拥有扎实的前端开发基础，熟练掌握HTML、CSS和JavaScript等核心技术。在Vue.js和React框架方面拥有丰富的实战经验，能够高效构建响应式、高性能的Web应用。注重代码质量和可维护性，善于团队合作，具备良好的问题解决能力和学习能力。
       
        <b>技术栈</b>
       
        - 前端技术：HTML5, CSS3 (包括Sass/Less), JavaScript (ES6+), TypeScript
        - 框架与库：Vue.js, React, Redux, Vuex, React Router, Vue Router
        - 构建工具：Webpack, Gulp, NPM/Yarn
        - 状态管理：Redux, Vuex
        - UI框架：Bootstrap, Vuetify, Ant Design, Material-UI
        - 版本控制：Git
        - 测试：Jest, Mocha, Enzyme, Vue Test Utils
        - 其他：Node.js, Express, MongoDB (了解)
        `,
        en:`
        I am a young man who loves programming. I like exploring new technologies, challenging myself and solving problems.

        I will study hard and improve my skills, hoping to contribute to the team. My technology stack includes HTML, CSS, JavaScript, Vue.js, React and so on.
        
        Have a solid foundation of front-end development and master core technologies such as HTML, CSS and JavaScript. He has rich practical experience in Vue.js and React framework, and can efficiently build responsive and high-performance Web applications. Pay attention to code quality and maintainability, be good at teamwork, have good problem solving ability and learning ability.
        
        <b> technology stack </b>
        
        -Front-end technologies: HTML5, CSS3 (including Sass/LESS), JavaScript (ES6+), TypeScript.
        -framework and library: vue.js, react, Redux, vuex, react router, vuerouter.
        -build tools: Webpack, Gulp, NPM/Yarn.
        -state management: Redux, Vuex
        -UI framework: bootstrap, vuetify, ant design, material-ui.
        -version control: Git
        -testing: Jest, Mocha, Enzyme, Vue Test Utils.
        -others: Node.js, Express, MongoDB (understanding)
        `
    }, 
    project_title:{
        en:'My Project',
        zh:'我的项目'
    },
    projectList:{
        en:[
            {
                title:'Resume online production',
                desc:'The online resume production platform developed by vue can be used to fill in personal basic information, educational experience, work experience, personal skills and other data, and can also change related topics. After production, it can be exported to pdf for saving or sharing.',
                code:'https://gitee.com/wu-kangkang/pdf-export',
                preview:'',
                tags:['Vue','Html','Css','JavaScript'],
                img:'pdf-export.png'
            },
            {
                title:'Recreational fishing',
                desc:'Use the front-end three-piece suite for development, mainly design css-related animations, use js to realize some animations, and use the keypad to put and put rods, and there are related sound effects to remind them.',
                code:'https://gitee.com/wu-kangkang/phishing',
                preview:'',
                tags:['Html','Css','JavaScript'],
                img:'fish.png'
                
            }
        ],
        zh:[
            {
                title:'简历在线制作',
                desc:'使用vue进行开发的在线简历制作平台，可进行个人基本信息、教育经历、工作经历、个人技能等数据的填写，也可以进行相关主题的更改，制作完成后可以进行导出为pdf进行保存或分享。',
                code:'https://gitee.com/wu-kangkang/pdf-export',
                preview:'',
                tags:['Vue','Html','Css','JavaScript'],
                img:'pdf-export.png'
            },
            {
                title:'休闲钓鱼',
                desc:'使用前端三件套进行开发，主要设计css相关动画，使用js实现部分动画，使用小键盘↑ ↓ 进行放杆、上杆操作，并存在相关音效进行提醒。',
                code:'https://gitee.com/wu-kangkang/phishing',
                preview:'',
                tags:['Html','Css','JavaScript'],
                img:'fish.png'
                
            }
        ]
    },
    skill_title:{
        en:'My Skill',
        zh:'我的技能'
    },
    skillList:{
        en:['Html','Css','JavaScript','Vue','React','Node.js','Express','Egg','Mysql','Python'],
        zh:['Html','Css','JavaScript','Vue','React','Node.js','Express','Egg','Mysql','Python']
    },
    experience_title:{
        en:'My Experience',
        zh:'我的经历'
    },
    experienceList:{
        en:[
            {
                title:'Front-end Development Engineer',
                units:"Xi 'an xxx Network Technology Co., Ltd.",
                desc:`
                Requirements analysis: Work closely with product managers and UI/UX designers to deeply understand business requirements and turn them into technical solutions.
                Architecture design: Participate in front-end architecture design, determine technology selection, and design component and modular front-end architecture.
                Core function development: responsible for the front-end development of core modules such as course list, video playback and course review.
                Performance optimization: implement strategies such as code splitting and lazy loading to improve page loading speed and responsiveness.
                Unit test and integration test: write and maintain unit test cases to ensure code quality.
                Code review: Participate in team code review to improve code quality and promote knowledge sharing.
                Deployment and maintenance: participate in CI/CD process configuration, ensure the smooth deployment of the project, continuously monitor the system performance, and solve online problems in time.
                `,
                label:'February 2021 - April 2023'
            }
        ],
        zh:[
            {
                title:'前端开发工程师',
                units:'西安xxx网络科技有限公司',
                desc:`
                需求分析：与产品经理、UI/UX设计师紧密合作，深入理解业务需求，转化为技术实现方案。
                架构设计：参与前端架构设计，确定技术选型，设计组件化、模块化的前端架构。
                核心功能开发：负责课程列表、视频播放、课程评论等核心模块的前端开发工作。
                性能优化：实施代码分割、懒加载等策略，提升页面加载速度和响应性。
                单元测试与集成测试：编写和维护单元测试用例，确保代码质量。
                代码审查：参与团队代码审查，提升代码质量，促进知识共享。
                部署与维护：参与CI/CD流程配置，确保项目顺利部署，并持续监控系统性能，及时解决线上问题。
                `,
                label:'2021年02月 - 2023年04月'
            }
        ]
    }
    
}

export function debounce(func, delay, immediate){
    var timer = null;
    return function(){
        var context = this;
        var args = arguments;
        if(timer) clearTimeout(timer);
        if(immediate){
            var doNow = !timer;
            timer = setTimeout(function(){
                timer = null;
            },delay);
            if(doNow){
                func.apply(context,args);
            }
        }else{
            timer = setTimeout(function(){
                func.apply(context,args);
            },delay);
        }
    }
}


// WEBPACK FOOTER //
// ./src/utils/configured.js